import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {HttpErrorHandlerService} from '@shared-services/http-error-handling.service';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {catchError, Observable, throwError} from 'rxjs';
import {LazyLoaderService} from '@shared-services/lazy-loader.service';
import {LogoutService} from 'src/app/layout/services/logout.service';
import {UserInfoService} from '../services/user-info.service';
import {Router} from '@angular/router';

@Injectable()
export class DefaultErrorInterceptor implements HttpInterceptor {
  private unauthorizedCount = 0;

  constructor(
    private notiService: NzNotificationService,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private lazyLoaderService: LazyLoaderService,
    private logoutService: LogoutService,
    private userInfoService: UserInfoService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse ) => {

        if (error.status === 401) {
          this.unauthorizedCount++;
          if (this.unauthorizedCount === 1 && !window.location.href.includes('login')) {
            this.userInfoService.userLogout('sessiontimeout');
          }
        } else {
          if (this.unauthorizedCount > 0) {
            this.unauthorizedCount--;
          }
        }

        if (error.status === 403) {
          // this.logoutService.clearUserSession();
        }

        this.lazyLoaderService.showLoader();
        return throwError(()=>  error);
      })
    );
  }
}
